import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_roster_member.breadcrumb.roster_member_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_roster_member.breadcrumb.roster_member_label2'),
    link: '/application/team',
  },
  {
    label: t('pages.application_roster_member.breadcrumb.roster_member_label3'),
  },
];
